import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import base_url from "../../Utils/server";
import { Link, useSearchParams } from "react-router-dom";

const ResetPassword = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  //has number
  const hasNumber = (number) => new RegExp(/[0-9]/).test(number);

  // has mix of small and capitals
  const hasSmall = (number) => new RegExp(/[a-z]/).test(number);
  const hasCapital = (number) => new RegExp(/[A-Z]/).test(number);

  // has special chars
  const hasSpecial = (number) => new RegExp(/[!#@$%^&*)(+=._-]/).test(number);

  const [length, setLength] = useState(0);

  useEffect(() => {
    const passwordInput = document.getElementById("password");
    const updateLength = () => {
      setLength(passwordInput.value.length);
    };

    passwordInput.addEventListener("input", updateLength);

    return () => {
      passwordInput.removeEventListener("input", updateLength);
    };
  }, []);

  // set color based on password strength
  const strengthColor = (count) => {
    if (count < 2) return { label: "Poor", color: "Red" };
    if (count < 3) return { label: "Weak", color: "yellow" };
    if (count < 4) return { label: "Normal", color: "dark-yellow" };
    if (count < 5) return { label: "Good", color: "Green" };
    if (count < 6) return { label: "Strong", color: "DarkGreen" };
    return { label: "Poor", color: "Red" };
  };
  function passwordStrength() {
    let password = document.getElementById("password").value;
    if (length > 0) {
      let colorDiv = document.getElementById("passwordStrengthColor");
      let Strength = document.getElementById("passwordStrengthValue");
      let count = strengthIndicator(password);
      let obj = strengthColor(count);
      colorDiv.style.backgroundColor = obj.color;
      Strength.innerHTML = `${obj.label}`;
    }
  }

  // password strength indicator
  const strengthIndicator = (number) => {
    let strengths = 0;
    if (number.length > 7) strengths += 1;
    if (hasNumber(number)) strengths += 1;
    if (hasSpecial(number)) strengths += 1;
    if (hasCapital(number)) strengths += 1;
    if (hasSmall(number)) strengths += 1;
    if (number.length < 8) strengths = 1;

    return strengths;
  };

  function ConfirmPassword() {
    if (
      document.getElementById("password").value !==
        document.getElementById("confirm_password").value ||
      document.getElementById("password").value === ""
    ) {
      document
        .getElementById("confirm_password")
        .classList.add("focus:border-red-600");
      document
        .getElementById("confirm_password")
        .classList.remove("focus:border-green-600");
    } else {
      document
        .getElementById("confirm_password")
        .classList.add("focus:border-green-600");
      document
        .getElementById("confirm_password")
        .classList.remove("focus:border-red-600");
    }
  }
  function handlePasswordReset() {
    let em = document.getElementById("em").value;
    let pass = document.getElementById("password").value;
    let cPass = document.getElementById("confirm_password").value;
    const id = toast.loading("Checking Details...", {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (pass != cPass) {
      toast.update(id, {
        render: "Passwords do not match.",
        type: "error",
        isLoading: false,
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
      });
      return;
    }
    axios
      .post(`${base_url}/newPassword`, {
        email: em,
        userPassword: pass,
        passwordTokengiven: searchParams.get("id"),
      })
      .then((res) => {
        if (res.data.status != "fail") {
          setTimeout(
            function () {
              toast.update(id, {
                render: "Password Updated Successfully",
                type: "success",
                isLoading: false,
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
              setTimeout(function () {}, [1500]);
            },
            [700]
          );
          let forgetform = document.getElementById("forgetform");
          forgetform.reset();
          let colorDiv = document.getElementById("passwordStrengthColor");
          let Strength = document.getElementById("passwordStrengthValue");
          if (colorDiv) {
            colorDiv.style.display = "none";
          }
          if (Strength) {
            Strength.style.display = "none";
          }
        } else {
          toast.error(res.data.message)
        }
      })
      .catch((e) => {
        setTimeout(
          function () {
            toast.update(id, {
              render: e.toString() || "Network Error",
              type: "error",
              isLoading: false,
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1000,
            });
          },
          [500]
        );
      });
  }
  return (
    <>
      <div className="relative overflow-y-auto p-4">
        <h5 className="text-3xl text-center font-bold text-blue-800 dark:text-neutral-200">
          Reset Your Password -
        </h5>
        <form
          id="forgetform"
          onSubmit={(e) => e.preventDefault()}
          className="space-y-5 m-8 border-2 rounded-md p-8"
        >
          <div>
            <label className="font-medium">Email :</label>
            <input
              type="email"
              required
              id="em"
              name="email"
              className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
            />
          </div>
          <div>
            <label className="font-medium">Password :</label>
            <input
              type="password"
              required
              id="password"
              name="Password"
              pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?!.*[\s\t]).{8,20}$"
              onChange={passwordStrength}
              className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg"
            />
            {length > 0 && (
              <div className="flex items-center gap-3 m-1">
                <div className="font-small" id="passwordStrengthValue"></div>
                <div
                  className="h-2 w-20 rounded-lg"
                  id="passwordStrengthColor"
                ></div>
              </div>
            )}
          </div>
          <div>
            <label className="font-medium">Confirm Password :</label>
            <input
              type="password"
              required
              id="confirm_password"
              name="Password"
              pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?!.*[\s\t]).{8,20}$"
              onChange={ConfirmPassword}
              className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border  shadow-sm rounded-lg"
            />
          </div>
          <button></button>
        </form>
      </div>
      <div className="flex justify-center w-screen">
        <button
          onClick={() => {
            handlePasswordReset();
          }}
          type="button"
          className="ml-1 inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
        >
          Update
        </button>
        <Link to="/">
          <button
            type="button"
            className="ml-1 inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
          >
            Go back to Login
          </button>
        </Link>
      </div>
    </>
  );
};

export default ResetPassword;
